export function isImgLink(url) {
  if (typeof url !== "string") return false;
  return (
    /* eslint-disable no-useless-escape */
    url.match(/^http[^\?]*.(jpg|jpeg|gif|png|tiff|bmp)(\?(.*))?$/gim) != null
  );
}
